export class LinkHarnessController {}
